import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import moment from "moment/moment";

export default function DropdownQuarter({ name, kName, option, filterData, filterCallBack }) {
    const [data, setData] = useState(name);
    const [selectOptions, setSelectOptions] = useState({ completionDate:"" });

    useEffect(() => {
        setSelectOptions(filterData);
    }, [filterData]);

    useEffect(() => {
        if (option.length > 0) {
            const [startDate, endDate] = filterData?.[kName].split("&");
            if (endDate) setData(filterData?.[kName] || endDate ? `Q${moment(endDate).format('Q YYYY')}` : name);
            else setData(filterData?.[kName] ? `Q${moment(filterData?.[kName]).format('Q YYYY')}`  : name);
        }
    }, [filterData, name, option]);

    const handleDropdown = (value, name) => {
        const [quarter, year] = value.split(" ");
        let startDate, endDate;
        switch (quarter) {
            case "Q1":
                startDate = new Date(`${year}-01-01`);
                endDate = new Date(`${year}-03-31`);
                break;
            case "Q2":
                startDate = new Date(`${year}-04-01`);
                endDate = new Date(`${year}-06-30`);
                break;
            case "Q3":
                startDate = new Date(`${year}-07-01`);
                endDate = new Date(`${year}-09-30`);
                break;
            case "Q4":
                startDate = new Date(`${year}-10-01`);
                endDate = new Date(`${year}-12-31`);
                break;
            default:
                return;
        }
        // const optionData = selectOptions;
        const optionData = { ...selectOptions };
        optionData["completionDate"] = `${startDate.toISOString().split(".")[0]}&${endDate.toISOString().split(".")[0]}`;
        setSelectOptions(optionData);
        filterCallBack(optionData);
    };
    return (
        <div className={`filter-dropdown year-dropdown dropdown_height`}>
            <DropdownButton title={data}>
                {/* <DropdownButton title={data ? data : name}> */}
                <div className="dropdown-grid">
                    {option.map((value, i) => (
                        <Dropdown.Item as="span" key={i} className={data == value.name ? "active" : ""} onClick={() => handleDropdown(value.name, "completionDate")}>
                            {value?.name}
                        </Dropdown.Item>
                    ))}
                </div>
            </DropdownButton>
        </div>
    );
}
